import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import math from '@/mixins/math'
import NtrPaslaugosMap from '../components/ntrpaslaugos/NtrPaslaugosMap'
export default {
  mixins: [userRole, busena, math],
  data() {
    return {
      showModalBusena: false,
      modalBusenaWithSign: false,
      modalBusena: null,
      modalBusenaTekstui: null,
      modalBusenaRefresh: 0,
      perskaiciuotiTermina: false,
    }
  },
  computed: {
    ...mapGetters([
      'signBusena',
      'prasymasTipas',
      'prasymasOwner',
      'prasymasSignStatus',
      'pasirasymasVadovas',
      'prasymasBusenaTolimesne',
      'savitarnaKrepselisUrl',
    ]),
    isSign() {
      return this.$route.params.sign
    },
    modalBusenaKey() {
      return `busena-${this.modalBusenaRefresh}`
    },
    needSign() {
      return this.prasymasSignStatus === 'not_signed'
    },
    showLaukiaPasirasymoInfo() {
      return this.prasymasOwner && this.isLaukiaPatvirtinimo
    },
    dokumentasTipas() {
      return NtrPaslaugosMap.getPrasymasTipas(this.prasymasTipas).title
    },
  },
  created() {
    if (this.isSign && this.signBusena) {
      this.openBusena(this.signBusena, true)
    }
  },
  methods: {
    validate(button) {
      let ans = false
      switch (button) {
        case 'Tęsti':
          ans = this.stepIndex < this.steps.length - 1
          break
        case 'Atgal':
          ans = this.stepIndex > 0
          break
        case 'Tikrinti savitarna':
          ans = this.isRengiamas || this.isGrazintas
          break
        case 'Tikrinti':
          ans = this.isPerduotas
          break
        case 'Patvirtinti savitarna':
          ans =
            (this.isRengiamas || this.isGrazintas) &&
            this.prasymasOwner &&
            this.isStepRegistravimas
          break
        case 'Pasirasyti savitarna':
          ans =
            this.isLaukiaPatvirtinimo &&
            this.needSign &&
            this.isStepRegistravimas
          break
        case 'Netvirtinti savitarna':
          ans =
            this.isLaukiaPatvirtinimo &&
            this.needSign &&
            this.isStepRegistravimas
          break
        case 'Apmoketi savitarna':
          ans =
            this.prasymasOwner &&
            this.isLaukiaApmokejimo &&
            this.isStepRegistravimas
          break
        case 'Perduoti':
          ans =
            (this.isRengiamas || this.isGrazintas) &&
            !this.pasirasymasVadovas &&
            this.isStepRegistravimas &&
            this.roleNotaras
          break
        case 'Pasirašyti perduotas':
          ans =
            (this.isRengiamas || this.isGrazintas) &&
            this.pasirasymasVadovas &&
            this.prasymasBusenaTolimesne === 'perduotas' &&
            this.isStepRegistravimas &&
            this.roleOr(['DT_notaras', 'DT_notaro_atstovas'])
          break
        case 'Registruoti':
          ans =
            this.isPerduotas &&
            !this.pasirasymasVadovas &&
            this.roleRG &&
            this.isStepRegistravimas &&
            !this.isReadonly
          break
        case 'Grąžinti tikslinti':
          ans =
            this.isPerduotas &&
            this.roleRG &&
            !this.pasirasymasVadovas &&
            !this.isReadonly
          break
        case 'Atmesti':
          ans =
            (this.isPerduotas || this.isGrazintas || this.isNepatikslintas) &&
            this.roleRG &&
            !(
              this.pasirasymasVadovas &&
              this.prasymasBusenaTolimesne !== 'perduotas'
            ) &&
            !this.isReadonly
          break
        case 'Pasirašyti vadovas':
          ans =
            (this.isPerduotas || this.isGrazintas || this.isNepatikslintas) &&
            this.pasirasymasVadovas &&
            this.prasymasBusenaTolimesne !== 'perduotas' &&
            this.role('RG_NTR_vadovas')
          break
        case 'Priskirti sau':
          ans =
            !this.appSavitarna &&
            this.roleRG &&
            (this.isPerduotas || this.isGrazintas) &&
            !this.isReadonly
          break
        case 'Atšaukti asmens prašymu':
          ans =
            !this.appSavitarna &&
            this.isPerduotas &&
            this.roleRG &&
            !(
              this.pasirasymasVadovas &&
              this.prasymasBusenaTolimesne !== 'perduotas'
            ) &&
            !this.isReadonly
          break
        case 'Word':
          ans = !this.appSavitarna && (this.roleRG || this.roleNotaras)
          break
      }

      return ans
    },
    openBusenaGrazintas(busena) {
      this.perskaiciuotiTermina = true
      this.openBusena(busena)
    },
    openBusena(busena, withSign = false, busenaTekstui = null) {
      this.loading = true
      this.modalBusenaWithSign = withSign
      if (!withSign) {
        this.$store.dispatch('signType', null)
      }
      this.modalBusena = busena
      this.modalBusenaTekstui = busenaTekstui ?? busena
      this.modalBusenaRefresh++
      this.showModalBusena = true

      this.loading = false
    },
    confirmBusena() {
      this.$store.dispatch('unlockPra').then(() => {
        this.$root.$emit('reloadPrasymasTab')
        this.$root.$emit('reloadPrasymasUpload')
        this.$root.$emit('reloadPrasymasInformacija')
        this.getData()
      })
    },
    loadedBusena() {
      this.perskaiciuotiTermina = false
    },
    moketiSavitarna(prasymasID = this.prasymasID) {
      this.loading = true

      const data = { pra_id: prasymasID }

      this.$axios
        .post(`ntrpaslaugos/prasymas/${prasymasID}/busena/perduotas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.$store.dispatch('checkErrors', null)
          if (res.data.krepselis) {
            this.gotoKrepselis(res.data.krepselis_id)
          } else {
            this.loading = false
            this.confirmBusena()
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
          this.$root.$emit('reloadPrasymasTab')
          this.$root.$emit('reloadPrasymasUpload')
        })
    },
    moketiSavitarnaPazyma(pazymaID = this.pazymaID) {
      this.loading = true

      this.$axios
        .post(`ntrpaslaugos/pazyma/${pazymaID}/veiksmas/pazyma-mokejimas`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.$store.dispatch('checkErrors', null)
          if (res.data.krepselis) {
            this.gotoKrepselis(res.data.krepselis_id)
            return
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    priskirtiSau() {
      this.loading = true

      const data = {}

      this.$axios
        .post(
          `ntrpaslaugos/prasymas/${this.prasymasID}/priskirti-naudotojui`,
          data
        )
        .then(res => {
          this.loading = false
          this.$root.$emit('reloadPrasymasTab')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
        })
    },
    printWord() {
      this.loading = true

      const data = { pra_id: this.prasymasID }

      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/perziura/word`, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          this.openFile(res.data)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err)
          // window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openFile(fileData) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute(
        'download',
        this.safeFileName(`${this.dokumentasTipas}.docx`)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    gotoKrepselis(krepselis_id = null) {
      this.loading = true
      if (krepselis_id) {
        window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${krepselis_id}`
        return
      }
      window.location.href = this.savitarnaKrepselisUrl
    },
  },
}
